<template lang="html">
  <div class="navContainer">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <router-link :to="{ name: 'Index' }" class="navbar-brand">Proove</router-link>
        <ul class="form-inline my-2 ml-auto my-lg-0">
          <form>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Find a friend" aria-label="Search" aria-describedby="button-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="submit" id="button-addon2"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </form>
          <ul class="navbar-nav mx-2 mt-2 mt-lg-0">
            <li v-if="!user" class="nav-item"><router-link :to="{ name: 'Join' }" class="nav-link">Join</router-link></li>
            <li v-if="!user" class="nav-item"><router-link :to="{ name: 'Login' }" class="nav-link">Login</router-link></li>
            <li v-if="user" class="nav-item"><router-link class="btn btn-primary text-white mx-2" :to="{ name: 'NewGoal' }">New Goal</router-link></li>
            <li v-if="user" class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ first }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
                <router-link :to="{ name: 'Profile', params: { username: this.username } }" class="dropdown-item">Profile</router-link>
                <router-link :to="{ name: 'Settings' }" class="dropdown-item">Account Settings</router-link>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" @click.prevent="LogOut">Log Out</a>
              </div>
            </li>
          </ul>
        </ul>
      </div>
    </nav>

  </div>
</template>

<script>
import db from '@/store/firebaseinit'
import firebase from 'firebase'

export default {
  name: 'Navbar',
  data() {
    return {
      user: null,
      first: null,
      username: 'profile'
    }
  },
  watch:{
    $route (to, from){
        if(this.$router.currentRoute.name == 'Profile') {
          this.ListenForProfileUpdates()
        }
    }
  },
  methods: {
    LogOut() {
      firebase.auth().signOut().then(function() {
        this.$router.push({ name: 'Index' })
      }.bind(this)).catch(function(error) {
        console.log(error)
      });
    },
    ListenForProfileUpdates() {
      // Listen for updates to user information
      let ref = db.collection('users').doc(this.user.uid)
      ref.onSnapshot(snapshot => {
        this.user = firebase.auth().currentUser
        if(this.user) {
          var displayName = this.user.displayName.split(" ")
          this.first = displayName[0]
          this.username = snapshot.data().username
        }
      })
    },
  },
  beforeCreate() {
    if(firebase.auth().currentUser) {
      this.user = firebase.auth().currentUser
      db.collection('users').doc(this.user.uid).get()
      .then(result => {
        this.username = result.data().username
      }).catch(error => {
        console.log(error.message)
      })
    }

  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        this.user = firebase.auth().currentUser
        this.ListenForProfileUpdates()
      } else {
        this.first = null
        this.user = null
      }
    })
  }
}
</script>

<style lang="css">
a:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/utility/Navbar.vue